import React from "react";
import { useFormik } from "formik";
import { useSaveRtoMutation, useCompleteRtoMutation } from "state/api";
import { Button, Divider, MenuItem, Select, TextField } from "@mui/material";
import {
  rtoStageDropdown,
  rtoStatusDropdown1,
  rtoStatusDropdown2,
  rtoStatusDropdown3,
} from "./rtoDropdown";
import DisplayCard from "./DisplayCard";
import { MuiFileInput } from "mui-file-input";
import Timeline from "./Timeline";

const Rto = ({ data, setLoader }) => {
  const [saveRto] = useSaveRtoMutation();
  const [completeRto] = useCompleteRtoMutation();

  const formik = useFormik({
    initialValues: {
      followUpDate:
        new Date().toISOString().slice(0, 11) +
        new Date().toLocaleTimeString().slice(0, 5),
      followUpStage:
        data?.rto?.followUps[-1]?.followUpStage || rtoStageDropdown[0],
      followUpStatus:
        data?.rto?.followUps[-1]?.followUpStatus || rtoStatusDropdown1[0],
      followUpRemarks: "",
      rtoFile: null,
    },
    onSubmit: (values) => {
      values.transactionId = data._id;

      const formData = new FormData();
      formData.append("transactionId", values.transactionId);
      formData.append("followUpDate", values.followUpDate);
      formData.append("followUpStage", values.followUpStage);
      formData.append("followUpStatus", values.followUpStatus);
      formData.append("followUpRemarks", values.followUpRemarks);
      formData.append("rtoFile", values.rtoFile);

      setLoader(true);
      saveRto(formData)
        .unwrap()
        .then((res) => {
          alert("RTO Status Updated");
          setLoader(false);
        })
        .catch((err) => {
          alert("RTO Status Update Failed");
          setLoader(false);
        });
    },
  });

  const handleComplete = () => {
    setLoader(true);
    completeRto({
      transactionId: data?._id,
      rtoId: data?.rto?._id,
    })
      .unwrap()
      .then((res) => {
        alert("RTO Completed");
        setLoader(false);
        window.location.reload();
      })
      .catch((err) => {
        alert("RTO Completion Failed");
        setLoader(false);
      });
  };

  return (
    <>
      <div className="my-2 text-lg font-bold text-gray-700">RTO</div>
      <DisplayCard data={data} />
      <form onSubmit={formik.handleSubmit}>
        <div className="mt-4 grid grid-cols-2 gap-4">
          <TextField
            id="followUpDate"
            name="followUpDate"
            label="Date Time"
            type="datetime-local"
            value={formik.values.followUpDate}
            onChange={formik.handleChange}
            fullWidth
          />
          <TextField
            id="followUpRemarks"
            name="followUpRemarks"
            label="Remarks"
            type="text"
            value={formik.values.followUpRemarks}
            onChange={formik.handleChange}
            fullWidth
          />
          <Select
            id="followUpStage"
            name="followUpStage"
            value={formik.values.followUpStage}
            label="Stage"
            onChange={formik.handleChange}
            fullWidth
          >
            {rtoStageDropdown.map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
          <Select
            id="followUpStatus"
            name="followUpStatus"
            label="Status"
            value={formik.values.followUpStatus}
            onChange={formik.handleChange}
            fullWidth
          >
            {formik.values.followUpStage === rtoStageDropdown[0] &&
              rtoStatusDropdown1.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            {formik.values.followUpStage === rtoStageDropdown[1] &&
              rtoStatusDropdown2.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            {formik.values.followUpStage === rtoStageDropdown[2] &&
              rtoStatusDropdown3.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
          </Select>
          <MuiFileInput
            id="rtoFile"
            name="rtoFile"
            label="RTO File"
            value={formik.values.rtoFile}
            onChange={(value) => {
              formik.setFieldValue("rtoFile", value);
            }}
            fullWidth
          />
        </div>
        <div className="flex flex-row gap-2">
          <Button
            type="submit"
            className="my-4 bg-slate-600 hover:bg-slate-700 text-white w-24"
          >
            Update
          </Button>
          <Button
            type="button"
            className="my-4 bg-red-600 hover:bg-red-700 text-white "
            onClick={handleComplete}
          >
            Mark as Complete
          </Button>
        </div>
      </form>
      <Divider />
      <Timeline data={data} />
    </>
  );
};

export default Rto;
